const workspaceRequestStore = {
    workspaceById: {},
    inFlightById: {},
    creditSummaryByWorkspaceId: {},
    creditSummaryInFlightByWorkspaceId: {}
};

export function workspaceRequestDispatch(action) {
    switch (action.type) {
        case "CACHE_WORKSPACE_RESPONSE":
            workspaceRequestStore.workspaceById = {
                ...workspaceRequestStore.workspaceById,
                [action.payload.workspaceId]: {
                    fetchedAt: Date.now(),
                    response: action.payload.response
                }
            };
            return;
        case "SET_WORKSPACE_IN_FLIGHT":
            workspaceRequestStore.inFlightById = {
                ...workspaceRequestStore.inFlightById,
                [action.payload.workspaceId]: action.payload.requestPromise
            };
            return;
        case "CLEAR_WORKSPACE_IN_FLIGHT":
            const nextInFlightById = {...workspaceRequestStore.inFlightById};
            delete nextInFlightById[action.payload.workspaceId];
            workspaceRequestStore.inFlightById = nextInFlightById;
            return;
        case "CLEAR_WORKSPACE_CACHE":
            if (action.payload && action.payload.workspaceId !== undefined && action.payload.workspaceId !== null) {
                const nextWorkspaceById = {...workspaceRequestStore.workspaceById};
                const nextCreditSummaryByWorkspaceId = {...workspaceRequestStore.creditSummaryByWorkspaceId};
                const nextCreditSummaryInFlightByWorkspaceId = {...workspaceRequestStore.creditSummaryInFlightByWorkspaceId};
                delete nextWorkspaceById[action.payload.workspaceId];
                delete nextCreditSummaryByWorkspaceId[action.payload.workspaceId];
                delete nextCreditSummaryInFlightByWorkspaceId[action.payload.workspaceId];
                workspaceRequestStore.workspaceById = nextWorkspaceById;
                workspaceRequestStore.creditSummaryByWorkspaceId = nextCreditSummaryByWorkspaceId;
                workspaceRequestStore.creditSummaryInFlightByWorkspaceId = nextCreditSummaryInFlightByWorkspaceId;
                return;
            }

            workspaceRequestStore.workspaceById = {};
            workspaceRequestStore.inFlightById = {};
            workspaceRequestStore.creditSummaryByWorkspaceId = {};
            workspaceRequestStore.creditSummaryInFlightByWorkspaceId = {};
            return;
        case "CACHE_CREDIT_SUMMARY_RESPONSE":
            workspaceRequestStore.creditSummaryByWorkspaceId = {
                ...workspaceRequestStore.creditSummaryByWorkspaceId,
                [action.payload.workspaceId]: {
                    fetchedAt: Date.now(),
                    response: action.payload.response
                }
            };
            return;
        case "SET_CREDIT_SUMMARY_IN_FLIGHT":
            workspaceRequestStore.creditSummaryInFlightByWorkspaceId = {
                ...workspaceRequestStore.creditSummaryInFlightByWorkspaceId,
                [action.payload.workspaceId]: action.payload.requestPromise
            };
            return;
        case "CLEAR_CREDIT_SUMMARY_IN_FLIGHT":
            const nextCreditSummaryInFlight = {...workspaceRequestStore.creditSummaryInFlightByWorkspaceId};
            delete nextCreditSummaryInFlight[action.payload.workspaceId];
            workspaceRequestStore.creditSummaryInFlightByWorkspaceId = nextCreditSummaryInFlight;
            return;
        default:
            return;
    }
}

export function workspaceRequestGetState() {
    return workspaceRequestStore;
}
